export const comments_3319768 = {"data":{"data":[],"links":{}}}